import React from "react";
import { useTranslation } from "react-i18next";
import classNames from "classnames";
import { useServices } from "@/services-context";
import styles from "./view-details.module.scss";
import { useLayoutType, LayoutStyleTypes, LayoutTypes } from "@/util-react/layout";
import {FixButton} from "@/elements-react/fix-button";

export interface ViewDetailsProps {
  type?: LayoutStyleTypes.TYPE_LG | LayoutStyleTypes.TYPE_SM;
  disabled?: boolean;
  className?: string;
  onClick: () => void;
}

export const ViewDetails: React.FC<ViewDetailsProps> = ({
  type = LayoutStyleTypes.TYPE_LG,
  disabled = false,
  className,
  onClick,
  ...props
}) => {
  const { t } = useTranslation();
  useServices(); // SSR-compatible

  const getText = () => t("z1fgc55qbh3jc0fr.view-details", "View details");

  return (
    <div className={styles.wrapper}>
      <FixButton
        disabled={disabled}
        className={classNames(styles.button, styles[type], className)}
        {...props}
        fullWidth={true}
        onClick={onClick}
      >
        <span className={styles.label}>{getText()}</span>
      </FixButton>
    </div>
  );
};

export default ViewDetails;
